/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/CardValue.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useContext} from 'react';
import {TranslationsContext, FormContext} from "@proxy/_contexts";
import {TextField, FormSection, RadioButtons, TextFieldWarning} from "../../../_components";

export default function CardValue() {

  const translations = useContext(TranslationsContext);
  const {
    formData,
    formErrors,
    updateFormField,
    bulkOrder,
    amountChoices,
    giftCardCost,
    physicalSurcharge,
    fulfillmentType
  }  = useContext(FormContext);
  
  const handleChange = (value) => {
    updateFormField("id", value);
  };

  const handleCustomValueChange = (value) => {
    updateFormField("properties._gcp_custom_value", Number(value));
  };

  return (
    <>
    <FormSection
      title={translations.gift_card_value_heading}
    >
      <div className={"gc__giftcard_value_div"}>
        <RadioButtons
          groupName={"gc_value"}
          name={"id"}
          options={amountChoices.values}
          onChange={handleChange}
          value={formData.id}
          classes={"gc__no_column_row_gap gc__value-radio-container"}
        />
        {formErrors.id ? (<p className="gc__input_field_error_message">{formErrors.id.message}</p>) : <></>}
        {
          formData.id === "Custom" && bulkOrder === false ? (
            <>
              <TextField
                value={formData.properties._gcp_custom_value || ""}
                placeholder={translations.giftcard_value_placeholder}
                name="properties[_gcp_custom_value]"
                type={"number"}
                onChange={(e) => {
                  handleCustomValueChange(e.target.value);
                }}
                error={formErrors._gcp_custom_value}
              />
            </>
          ) : (
          <></>
        )
      }
      
      </div>
    </FormSection>
    {(fulfillmentType === "physical" && physicalSurcharge) ?
    (<div className="gc__form_help gc__physical_surcharge_warning"> 
      {translations.physical_surcharge_notice.replace("{amount}", physicalSurcharge.formatted)}
    </div>)
  : null}
  </>
  );
}
